module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre6",
    attrs: {
      "id": "pgepubid00012"
    }
  }, [_vm._v("My Own Self")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("In a tiny house in the North Countrie, far away from any town or village, there lived not long ago, a poor widow all alone with her little son, a six-year-old boy.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("The house-door opened straight on to the hill-side and all round about were moorlands and huge stones, and swampy hollows; never a house nor a sign of life wherever you might look, for their nearest neighbours were the \"ferlies\" in the glen below, and the \"will-o'-the-wisps\" in the long grass along the pathside.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("And many a tale she could tell of the \"good folk\" calling to each other in the oak-trees, and the twinkling lights hopping on to the very window sill, on dark nights; but in spite of the loneliness, she lived on from year to year in the little house, perhaps because she was never asked to pay any rent for it.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("But she did not care to sit up late, when the fire burnt low, and no one knew what might be about; so, when they had had their supper she would make up a good fire and go off to bed, so that if anything terrible "), _c('i', {
    staticClass: "calibre8"
  }, [_vm._v("did")]), _vm._v(" happen, she could always hide her head under the bed-clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("This, however, was far too early to please her little son; so when she called him to bed, he would go on playing beside the fire, as if he did not hear her.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("He had always been bad to do with since the day he was born, and his mother did not often care to cross him; indeed, the more she tried to make him obey her, the less heed he paid to anything she said, so it usually ended by his taking his own way.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("But one night, just at the fore-end of winter, the widow could not make up her mind to go off to bed, and leave him playing by the fireside; for the wind was tugging at the door, and rattling the window-panes, and well she knew that on such a night, fairies and such like were bound to be out and about, and bent on mischief. So she tried to coax the boy into going at once to bed:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("\"The safest bed to bide in, such a night as this!\" she said: but no, he wouldn't.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Then she threatened to \"give him the stick,\" but it was no use.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("The more she begged and scolded, the more he shook his head; and when at last she lost patience and cried that the fairies would surely come and fetch him away, he only laughed and said he wished they "), _c('i', {
    staticClass: "calibre8"
  }, [_vm._v("would")]), _vm._v(", for he would like one to play with.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("At that his mother burst into tears, and went off to bed in despair, certain that after such words something dreadful would happen; while her naughty little son sat on his stool by the fire, not at all put out by her crying.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("But he had not long been sitting there alone, when he heard a fluttering sound near him in the chimney and presently down by his side dropped the tiniest wee girl you could think of; she was not a span high, and had hair like spun silver, eyes as green as grass, and cheeks red as June roses. The little boy looked at her with surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "\"...the tiniest wee girl you could think of...\"",
      "src": "Images/img0003.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("\"Oh!\" said he; \"what do they call ye?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("\"My own self,\" she said in a shrill but sweet little voice, and she looked at him too. \"And what do they call ye?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("\"Just my own self too!\" he answered cautiously; and with that they began to play together.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("She certainly showed him some fine games. She made animals out of the ashes that looked and moved like life; and trees with green leaves waving over tiny houses, with men and women an inch high in them, who, when she breathed on them, fell to walking and talking quite properly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("But the fire was getting low, and the light dim, and presently the little boy stirred the coals with a stick to make them blaze; when out jumped a red-hot cinder, and where should it fall, but on the fairy child's tiny foot.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Thereupon she set up such a squeal, that the boy dropped the stick, and clapped his hands to his ears but it grew to so shrill a screech, that it was like all the wind in the world whistling through one tiny keyhole.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("There was a sound in the chimney again, but this time the little boy did not wait to see what it was, but bolted off to bed, where he hid under the blankets and listened in fear and trembling to what went on.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "\"...caught the creature by its ear...\"",
      "src": "Images/img0004.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("A voice came from the chimney speaking sharply:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("\"Who's there, and what's wrong?\" it said.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("\"It's my own self,\" sobbed the fairy-child; \"and my foot's burnt sore. O-o-h!\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("\"Who did it?\" said the voice angrily; this time it sounded nearer, and the boy, peeping from under the clothes, could see a white face looking out from the chimney-opening.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("\"Just my own self too!\" said the fairy-child again.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("\"Then if ye did it your own self,\" cried the elf-mother shrilly, \"what's the use o' making all this fash about it?\"—and with that she stretched out a long thin arm, and caught the creature by its ear, and, shaking it roughly, pulled it after her, out of sight up the chimney.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("The little boy lay awake a long time, listening, in case the fairy-mother should come back after all; and next evening after supper, his mother was surprised to find that he was willing to go to bed whenever she liked.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("\"He's taking a turn for the better at last!\" she said to herself; but he was thinking just then that, when next a fairy came to play with him, he might not get off quite so easily as he had done this time.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('a', {
    attrs: {
      "id": "The_Black_Bull_of_Norroway"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "The Black Bull of Norroway",
      "src": "Images/img0005.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31b23160","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0008.vue
// module id = 78
// module chunks = 0